import React, { useEffect } from 'react'
import { SortByOptions } from 'enums'

import { createDocumentSearch } from 'utils/runSearchUtil'
import { getInsightContentData } from 'features/insightContent/asyncThunks'
import { useAppDispatch } from 'app/hooks'
import InsightContentType from 'components/insightContent/enum/InsightContentType'
import PostTypeGroup from 'enums/PostTypeGroup'
import FilterVo from 'vo/Filter'
import useRefreshTimestamp from 'hooks/useRefreshTimestamp'

import { InsightContentSettingType } from '../types'
import { SoundbitesSortTypeStrings } from '../enum/SoundbitesSortType'

const DEFAULT_SOUNDBITE_COUNT = 25
const IGNORE_SENTIMENT = true

const createDocumentRetrievalSearch = (
  detailSetting: InsightContentSettingType,
  sortBy: SoundbitesSortTypeStrings
) => {
  const { topicId, precision, selectionFilter } = detailSetting

  const postFilter = FilterVo()

  postFilter.includedPosts = selectionFilter?.includedPosts
  postFilter.postTypeGroups = [PostTypeGroup.DISPLAY_COMMENTS]

  return createDocumentSearch(
    -1,
    '',
    [topicId!],
    postFilter,
    precision,
    sortBy || SortByOptions.TIME,
    DEFAULT_SOUNDBITE_COUNT,
    IGNORE_SENTIMENT
  )
}

const RunSearchEffect = ({
  detailSetting,
  sortBy,
  children
}: {
  detailSetting: InsightContentSettingType
  sortBy: SoundbitesSortTypeStrings
  children: React.ReactNode
}) => {
  const dispatch = useAppDispatch()
  const refreshTimestamp = useRefreshTimestamp()

  useEffect(() => {
    const searches = createDocumentRetrievalSearch(detailSetting, sortBy)

    dispatch(
      getInsightContentData({
        insightContentType: InsightContentType.COMMENT,
        searches: [searches!],
        timestamp: refreshTimestamp
      })
    )
  }, [dispatch, detailSetting, sortBy, refreshTimestamp])

  return <>{children}</>
}

export default RunSearchEffect
